import styled from "styled-components"

export const Wrapper = styled.div`
  display: grid;
  margin-top: 50px;

  #post {
    width: 90%;
    margin: 0 auto;
    background-color: #fff;
    padding: 50px 20px;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 20px;
  }

  .gatsby-image-wrapper {
    width: 100%;
    height: 300px;
    object-fit: cover;
    padding: 0 20px;
  }

  .post_details li,
  .post_details p {
    margin: 0;
    padding: 0;
  }

  .post_details {
    padding: 20px;
  }

  .post_details h2 {
    font-weight: bold;
    font-size: 24px;
    line-height: 28px;
    color: #777d71;
    margin-bottom: 20px;
  }

  .post_content {
    margin-bottom: 50px;
    word-wrap: break-word;

    figure img {
      width: 100%;
    }
  }

  .post_details strong {
    font-weight: 900;
  }

  .post_details p,
  .post_details li {
    margin-bottom: 10px;
    font-size: 0.7rem;
    line-height: 1rem;
    letter-spacing: 0.1em;
  }

  .post_meta {
    display: flex;
    justify-content: space-between;
    border-top: 1px solid #bbd38b;
    padding: 10px 0;
    font-size: 14px;
    line-height: 16px;
  }

  .post_meta p {
    color: #bbd38b;
  }

  .tags_container {
    display: flex;
    flex-direction: row;
    margin: 0;
    padding: 0;

    li.tag {
      list-style: none;
      margin-right: 10px;
      cursor: pointer;
      & a {
        padding: 5px 8px;
        font-size: 12px;
        background-color: #777d71;
        color: #fff;
        text-decoration: none;
      }
    }
  }

  #comments {
    width: 100%;
  }
`

export const CommentCard = styled.div`
  margin-bottom: 50px;
  display: flex;

  .profile {
    width: 50px;
    height: 50px;
    margin-right: 20px;
  }

  .profile p.name {
    font-weight: bold;
    font-size: 12px;
    line-height: 14px;
    color: #777d71;
    margin: 0;
  }

  .profile p.comment-date {
    font-weight: bold;
    font-size: 8px;
    line-height: 9px;
    color: #d6d6d6;
  }

  .replies {
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
  }

  .replies span {
    font-weight: bold;
    font-size: 12px;
    line-height: 14px;
    color: #777d71;
  }
`
